import React from 'react'
import Galleries from '../../components/galleries/galleries.js'
import Layout from '../../layouts/index.js'

const array = [
  '008400',
  '008414',
  '008426',
  '008436',
  '008476',
  '008477',
  '008505',
  '008513',
  '008522',
  '008538',
  '008573',
  '008580',
  '008593',
  '008612',
  '008616',
  '008627',
  '008635',
  '008636',
  '008641',
]

const images = array.map((image) => {
  return (
    <figure>
      <img
        alt=""
        key={image}
        src={require('../../images/gallery/japan-in-winter/' + image + '.jpg')}
      />
    </figure>
  )
})

const JapanInWinter = () => (
  <Layout>
    <section>
      <h1>Japan in Winter</h1>
      {images}
      <Galleries />
    </section>
  </Layout>
)

export default JapanInWinter
